import React, {FC} from 'react';
import {Typography} from '@bonprix/design-system';

import LegalLinks from './LegalLinks';
import type {StaticLinks} from './CheckoutFooter';

interface LegalSectionProps {
    texts: {[key: string]: string};
    staticLinks: StaticLinks;
}

const LegalSection: FC<LegalSectionProps> = ({texts, staticLinks}) => {
    return (
        <div className="flex flex-col gap-6 py-4 l:py-0">
            <LegalLinks texts={texts} staticLinks={staticLinks} />
            <Typography color="on-bg-mid" align="center">
                {texts.disclaimer}
            </Typography>
            <Typography variant="body2" color="on-bg-mid" align="center">
                {texts.copyrightSign} {texts.copyrightYearCompany}
            </Typography>
        </div>
    );
};

export default LegalSection;
